import * as dataValidationReducer from '../reducers/dataValidation';

export const setDataValidationTableFilters = filters => dispatch => {
  dispatch(dataValidationReducer.SET_DATA_VALIDATION_TABLE_FILTERS(filters));
};

export const setEntryDetailsTableFilters = filters => dispatch => {
  dispatch(dataValidationReducer.SET_ENTRY_DETAILS_TABLE_FILTERS(filters));
};
